import React, { useState } from 'react';
import { loginAPI } from '../api';

export default function LoginScreen() {
  const [email, setEmail] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  // login_error の URL クエリを反映
  React.useEffect(() => {
    const q = new URLSearchParams(window.location.search);
    const err = q.get('login_error');
    if (err) {
      const map = {
        token_expired: 'リンクの有効期限が切れています (15 分以内にお開きください)',
        token_already_used: 'このリンクは既に使用済みです',
        invalid_token: '無効なリンクです',
        missing_token: 'トークンがありません',
        not_allowed: 'このメールアドレスは登録されていません',
        server_error: 'サーバーエラー (時間をおいて再試行)',
      };
      setError(map[err] || `ログインエラー: ${err}`);
      window.history.replaceState({}, '', window.location.pathname);
    }
  }, []);

  async function submit(e) {
    e && e.preventDefault();
    if (!email.trim() || submitting) return;
    setSubmitting(true); setError(''); setMessage('');
    try {
      const r = await loginAPI.request(email.trim());
      setMessage(r.data.message || 'メールを送信しました');
      setEmail('');
    } catch (e) {
      setError(e.response?.data?.message || e.message || '送信失敗');
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <div style={{
      minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
      background: 'linear-gradient(135deg, #0a0a0f 0%, #1a1a2e 100%)', padding: 20, fontFamily: 'system-ui, sans-serif',
    }}>
      <div style={{
        background: '#fff', borderRadius: 16, padding: 40, maxWidth: 440, width: '100%',
        boxShadow: '0 24px 60px rgba(0,0,0,0.5)',
      }}>
        <div style={{ textAlign: 'center', marginBottom: 24 }}>
          <div style={{ fontSize: 28, fontWeight: 800, color: '#0a0a0f', marginBottom: 6 }}>𝕏 AutoPost</div>
          <div style={{ fontSize: 13, color: '#666' }}>株式会社ネクストビズ</div>
        </div>
        <h2 style={{ fontSize: 18, margin: '24px 0 8px', color: '#0a0a0f' }}>ログイン</h2>
        <p style={{ fontSize: 13, color: '#666', lineHeight: 1.6, margin: '0 0 20px' }}>
          メールアドレスを入力してください。<br />
          15 分有効のログイン用リンクをお送りします。
        </p>

        {error && (
          <div style={{ padding: '10px 14px', background: '#fef2f2', border: '1px solid #fecaca', borderRadius: 6, color: '#dc2626', fontSize: 13, marginBottom: 16 }}>{error}</div>
        )}
        {message && (
          <div style={{ padding: '10px 14px', background: '#f0fdf4', border: '1px solid #bbf7d0', borderRadius: 6, color: '#15803d', fontSize: 13, marginBottom: 16 }}>{message}</div>
        )}

        <form onSubmit={submit}>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="your@email.com"
            disabled={submitting}
            autoFocus
            style={{ width: '100%', padding: '12px 16px', fontSize: 15, border: '1px solid #ddd', borderRadius: 8, marginBottom: 16, boxSizing: 'border-box' }}
          />
          <button
            type="submit"
            disabled={submitting || !email.trim()}
            style={{
              width: '100%', padding: '12px 0', background: '#0a0a0f', color: '#fff', border: 'none',
              borderRadius: 8, cursor: submitting ? 'wait' : 'pointer', fontSize: 15, fontWeight: 700,
              opacity: (submitting || !email.trim()) ? 0.5 : 1,
            }}
          >{submitting ? '送信中...' : 'ログインリンクを送信'}</button>
        </form>

        <p style={{ fontSize: 11, color: '#999', textAlign: 'center', marginTop: 24, lineHeight: 1.6 }}>
          このサービスは登録済みのメンバーのみログインできます。<br />
          登録外のメールアドレスではリンクは届きません。
        </p>
      </div>
    </div>
  );
}
